import axios from "axios";
import queryString from "query-string";
import url from "../allUrl";
import tool from "../tool";
import { Toast } from "antd-mobile-v2";
import sessionStore from "./secsstion";
import { loadingShow, loadingHide } from "./tipTool";
import { createBrowserHistory } from "history";
axios.defaults.baseURL = url.serverUrl;
axios.defaults.timeout = 60000;
//axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
// axios.defaults.withCredentials = true
axios.defaults.crossDomain = true;
axios.defaults.headers.get["Content-Type"] =
  "application/x-www-form-urlencoded";
/**
 * 设置请求拦截器，添加token
 */
// 删除个人信息
function removeSectionData() {
  sessionStore.remove("token");
  sessionStore.remove("acount");
  sessionStore.remove("user_id");
  sessionStore.remove("nick_name");
  sessionStore.remove("refstoken");
  sessionStore.remove("tokenTime");
  tool.remove("userInfoData");
  createBrowserHistory().push("/");
}
// 取消请求;
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
// 全局变量，记录是否正在执行刷新令牌任务
let isRefreshing = false;
const cancelTokens = [];
const requestFreshToken = axios.create();
axios.interceptors.request.use(
  async (config) => {
    loadingShow();
    if (sessionStore.get("tokenTime")) {
      let newTime = new Date().getTime();
      let tokenTime = sessionStore.get("tokenTime");
      // 判断当前的时间大于token保存的时间时，重新请求刷新koken
      if (newTime > tokenTime) {
        config.cancelToken = source.token;
        cancelTokens.push(() => source.cancel("令牌无效取消请求"));
        await refreshingToken();
      }
    }
    if (sessionStore.get("token")) {
      config.headers["Blade-Auth"] = sessionStore.get("token");
      //config.headers["Tenant-Id"] = sessionStore.get("TENANT_ID");
    }
    if (config.url.includes("/file-manage/download/file")) {
      config.responseType = "blob";
    }
    return config;
  },
  (error) => {
    Toast.fail("请求出错" + error, 1);
    return Promise.reject(error);
  }
);

/**
 * 设置相应拦截器
 */
axios.interceptors.response.use(
  (response) => {
    loadingHide();
    return response.data;
  },
  (error) => {
    try {
      if (error && error.response) {
        if (error.response.status === 401) {
          Toast.fail("未授权，请重新登录", 1, () => {});
          removeSectionData();
        } else if (error.response.status === 403) {
          Toast.fail("您的访问被拒绝", 1);
        } else if (error.response.status === 404) {
          Toast.fail("未找到请求路径", 1);
        } else if (error.response.status === 500) {
          Toast.fail("服务器出错了", 1);
        } else if (error.response.status === 201) {
          return Promise.resolve(error.response);
        }
      }
    } catch (error) {
      Toast.fail("请求出错", 1);
    }
    loadingHide();
    return Promise.reject(error.response);
  }
);

// export const transform = obj => {
//     var arr = []
//     for (let i in obj) {
//         arr.push(i + '=' + obj[i])
//     }
//     return arr.join('&')
// }
// export const getUrl = (url, query) => {
//     return `${url}?${transform(query)}`
// }

/**
 * 用于并发请求，不直接使用
 * @param {请求地址} url
 * @param {请求参数} params
 */
export const get = (url, params = {}) => {
  return axios.get(url, { params: params });
};
export const headerGet = (url, params = {}, header) => {
  return axios({
    url,
    method: "get",
    headers: header,
    params: params,
  });
};

/**
 * 用户并发请求，不直接使用
 * @param {请求地址} url
 * @param {请求参数} data
 */
export const post = (url, data = {}, header) => {
  return axios({
    url,
    method: "post",
    headers: header,
    data: JSON.stringify(data),
  });
};
export const postRaw = (url, data = {}, header) => {
  return axios({
    url,
    method: "post",
    headers: header,
    data: queryString.stringify(data),
  });
};
export const put = (url, id, data = {}) => {
  return axios({
    url: `${url}/${id}`,
    method: "put",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data: JSON.stringify(data),
  });
};
export const del = (url, id, params = {}) => {
  return axios({
    url: `${url}/${id}`,
    method: "delete",
    params: params,
  });
};
export const ende = (url, id, params = {}) => {
  return axios({
    url: `${url}/${id}`,
    method: "put",
    params: params,
  });
};

export const postFormData = (url, data = {}) => {
  return axios({
    url,
    method: "post",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: queryString.stringify(data),
  });
};

/**
 * 并发请求
 * @param {请求数组[]} requests
 */
export const all = (requests = []) => {
  return axios
    .all(requests)
    .then(
      axios.spread((...result) => {
        return [...result];
      })
    )
    .catch((error) => {
      console.log(error);
    });
};
export const handleResult = (res, hint = true, data = false) => {
  if (res.code === 200) {
    if (hint) Toast.success(res.msg, 1);
    return res.data;
  } else {
    Toast.error(res.msg, 1);
    return data;
  }
};

export default {
  post,
  get,
  all,
  put,
  del,
  ende,
  handleResult,
  postFormData,
  headerGet,
  postRaw,
};
async function refreshingToken() {
  if (!isRefreshing) {
    let objData = {
      grant_type: "refresh_token",
      refresh_token: sessionStore.get("refstoken"),
      userId: sessionStore.get("user_id"),
      userCode: sessionStore.get("acount"),
    };
    isRefreshing = true;
    return new Promise((resolve, reject) => {
      requestFreshToken({
        method: "post",
        url: url.register.userLogin,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
        },
        data: queryString.stringify(objData),
      })
        .then((res) => {
          if (
            res.status == 200 &&
            res.data &&
            res.data.access_token &&
            res.data.refresh_token
          ) {
            let num = new Date().getTime() + (1000 * 60 * 15 - 4000);
            let newToken = `${res.data.token_type}   ${res.data.access_token}`;
            sessionStore.set("token", newToken);
            sessionStore.set("refstoken", `${res.data.refresh_token}`);
            sessionStore.set("tokenTime", num);
            resolve(res);
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.code &&
            error.response.data.code == 401
          ) {
            // cancelTokens.forEach(cancel => {
            //   cancel().catch()
            // })
            reject(error);
            Toast.fail("未授权，请重新登录", 1);
            setTimeout(() => {
              removeSectionData();
            }, 500);
          }
        })
        .finally(() => {
          isRefreshing = false;
        });
    });
  } else {
    // 阻塞当前请求
    return new Promise((resolve, reject) => {
      const id = setInterval(() => {
        if (!isRefreshing) {
          clearTimeout(id);
          resolve();
        }
      }, 1000);
    });
  }
}
